import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/system';
import { motion } from 'framer-motion';
export function PulsatingCircles(_a) {
    var _b = _a.duration, duration = _b === void 0 ? 2.1 : _b, _c = _a.size, size = _c === void 0 ? 7.25 : _c, _d = _a.max, max = _d === void 0 ? 2 : _d, _e = _a.min, min = _e === void 0 ? 1.01 : _e, children = _a.children, color = _a.color, _f = _a.offsets, offsets = _f === void 0 ? [0, 1.328, 2.048, 2.544, 2.912] : _f;
    var scaleKeyframes = [min, max];
    var opacityKeyframes = [0.4, 0];
    return (_jsxs(Wrapper, { children: [offsets.map(function (offset, index) { return (_jsx(Circles, { color: color, size: size, animate: {
                    scale: scaleKeyframes,
                    opacity: opacityKeyframes,
                }, transition: {
                    repeat: Infinity,
                    type: 'spring',
                    duration: duration,
                    delay: offset,
                } }, "pulse-circle".concat(index))); }), children, _jsx(InnerCircle, { color: color, size: size })] }));
}
var Circles = styled(motion.div, {
    shouldForwardProp: function (prop) { return prop !== 'color' && prop !== 'size'; },
})(function (_a) {
    var theme = _a.theme, color = _a.color, size = _a.size;
    return ({
        minHeight: "".concat(size, "rem"),
        minWidth: "".concat(size, "rem"),
        borderRadius: '99999px',
        backgroundColor: color || theme.palette.primary.main,
        position: 'absolute',
        zIndex: -2,
    });
});
var InnerCircle = styled('div', {
    shouldForwardProp: function (prop) { return prop !== 'color' && prop !== 'size'; },
})(function (_a) {
    var theme = _a.theme, color = _a.color, size = _a.size;
    return ({
        minHeight: "".concat(size, "rem"),
        minWidth: "".concat(size, "rem"),
        borderRadius: '99999px',
        backgroundColor: color || theme.palette.primary.main,
        position: 'absolute',
        zIndex: -1,
    });
});
// 1.00
// 1.50
// 1.83
// 2.08
// 2.28
// 2.45
// 2.59
// 2.71
// 2.82
// 2.92
// 3.01
var Wrapper = styled('div')({
    display: 'grid',
    placeItems: 'center',
    position: 'relative',
});
